var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mingxi',{attrs:{"mingxiMain_type":1,"mingxi_type":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }